import { render, staticRenderFns } from "./ScreensaverNextFlyer.vue?vue&type=template&id=32230668&scoped=true"
import script from "./ScreensaverNextFlyer.vue?vue&type=script&lang=js"
export * from "./ScreensaverNextFlyer.vue?vue&type=script&lang=js"
import style0 from "./ScreensaverNextFlyer.vue?vue&type=style&index=0&id=32230668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32230668",
  null
  
)

/* custom blocks */
import block0 from "@/locales/global.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-dresden%2Fweb%2Fwebapp%2Fsrc%2Fpages%2Fscreensaver%2FScreensaverNextFlyer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports